import { render, staticRenderFns } from "./OnlineQuotaApp.vue?vue&type=template&id=51419636"
import script from "./OnlineQuotaApp.vue?vue&type=script&lang=js"
export * from "./OnlineQuotaApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports